'use strict';

import $ from 'jquery';
import { initialiseFilters } from '../../../_scripts/_helper';
import CustomSelect from '../../atoms/custom-select/custom-select';
import flatpickr  from 'flatpickr';
import rangePlugin  from '../../../../node_modules/flatpickr/dist/plugins/rangePlugin';

export default class ListingFilter {
  constructor($selector) {
    let $selections = $('.listing-filter__selection', $selector);
    let $calendarField = $('.listing-filter__calendar', $selector);
    let $calendar = $('.listing-filter__calendar input', $selector);
    let $parentListingContainer = $selector.closest('.listing-container');
    let $pagination = $('.pagination', $selector);

    $selections.map((i, ele) => {
      let $this = $(ele);

      let selection = new CustomSelect($this);
    });

    // let startdateID = $calendar.data('id');
    // let enddateID = $('.flatpickr-enddate', $selector).attr('id');

    // if ($calendarField.length) {
    //   var startPicker = flatpickr(".flatpickr-startdate", {
    //     plugins: [new rangePlugin({ input: ".flatpickr-enddate"})]
    //   });
    // };
      


    // find all selects in this page [select1, select2]
    // loop the array, we need a param name, and the value
    // if i select one, it should return all filters

    initialiseFilters($selector, $pagination);

  }
}
